export { Recs } from './recs.page';
